import { defineMessages } from 'react-intl';

export default defineMessages({
  edit: 'Edit',
  gasPrice: 'Approximate tx cost',
});
